import { FC, useCallback, useEffect, useRef } from 'react';
import {
  MenuItem,
  Select as MUISelect,
  FormControl,
  SelectChangeEvent,
  Checkbox,
  Typography,
  FormLabel,
} from '@mui/material';
import { PolicyFixInput } from '../../../../types/issues-types';

const Select: FC<React.PropsWithChildren<SelectProps>> = ({
  options,
  name,
  displayName,
  multiSelect,
  onChange,
}) => {
  const onChangeCall = useCallback(
    (event: SelectChangeEvent<string[]>) => {
      onChange(name, event.target.value);
    },
    [name, onChange],
  );
  const menuOptionsRef = useRef<HTMLUListElement>(null);
  const selected = options.filter(o => o.selected);
  useEffect(() => {
    menuOptionsRef.current?.scrollTo(0, 0);
  }, []);
  return (
    <FormControl variant='standard' fullWidth>
      <FormLabel sx={{ textTransform: 'capitalize' }}>
        {displayName} ({selected.length} selected)
      </FormLabel>

      <MUISelect
        sx={{ mt: '8px !important' }}
        variant='standard'
        label={name}
        labelId={name}
        onChange={onChangeCall}
        multiple={multiSelect}
        renderValue={selected => selected.join(', ')}
        MenuProps={{
          MenuListProps: {
            variant: 'menu',
          },
        }}
        value={selected.map(o => o.name)}>
        {options.map(({ name, displayName, selected, info }) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={selected} />
            {displayName}
            {info && (
              <Typography
                variant='caption'
                color='text.secondary'
                sx={{ mx: 1 }}>
                [{info}]
              </Typography>
            )}
          </MenuItem>
        ))}
      </MUISelect>
    </FormControl>
  );
};

export interface SelectProps extends PolicyFixInput {
  onChange: (type: string, input: string | string[]) => void;
}

export default Select;
